import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL } from '../env';

const hotelApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${REACT_APP_API_URL}hotels`,
  }),
  tagTypes: ['Hotel'],
  endpoints: (builder) => ({
    fetchHotelDetails: builder.query({
      query: () => ({
        url: '/',
        method: 'GET',
      }),
      providesTags: (result, error) => error ? [] : ['Hotel', { type: 'Hotel', id: 'LIST' }],
    }),
  }),
});

export const { useFetchHotelDetailsQuery } = hotelApi;      
export default hotelApi;